import { render, staticRenderFns } from "./PFLoanTermsFront.vue?vue&type=template&id=c28b4094"
import script from "./PFLoanTermsFront.vue?vue&type=script&lang=js"
export * from "./PFLoanTermsFront.vue?vue&type=script&lang=js"
import style0 from "./PFLoanTermsFront.vue?vue&type=style&index=0&id=c28b4094&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports